var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('v-chart',{ref:"chart",attrs:{"options":_vm.options,"init":_vm.init,"echart":_vm.echart},on:{"update:echart":function($event){_vm.echart=$event},"contextmenu":_vm.contextmenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }